import { render, staticRenderFns } from "./SummaryContents-Wind.vue?vue&type=template&id=3ad5b754&"
import script from "./SummaryContents-Wind.vue?vue&type=script&lang=js&"
export * from "./SummaryContents-Wind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports